const mediaBreakpoints = {
  tablet: 768,
  desktop: 1024,
  desktopXl: 1600,
  me: 768,
  l: 960,
};

export default mediaBreakpoints;
